import { differenceInSeconds, differenceInMinutes, differenceInHours, differenceInDays, format, isToday, isYesterday, parseISO } from "date-fns";
import { t } from "i18next";

/**
 * Format a date string to a human readable format
 * e.g. "2025-01-01 12:00:00" -> "12:00pm, Jan 1"
 * @param dateString - The date string to format
 * @returns The formatted date string
 */

export var formatDateTime = function formatDateTime(dateString) {
  if (!dateString) return "";
  var date = typeof dateString === "string" ? parseISO(dateString) : new Date(dateString);
  var timeFormat = format(date, "h:mm aaa").toLowerCase();
  if (isToday(date)) {
    return "".concat(timeFormat, ", ").concat(t("today_key"));
  } else if (isYesterday(date)) {
    return "".concat(timeFormat, ", ").concat(t("yesterday_key"));
  } else {
    var dateFormat = format(date, "MMM d");
    return "".concat(timeFormat, ", ").concat(dateFormat);
  }
};

/**
 * Format a date string as a relative or absolute time.
 * e.g. "3 mins ago", "2 days ago", "Oct 1, 12:00pm". Absolute time is shown if the date is more than 1 month ago.
 * @param dateString - The date string to format
 * @returns The formatted relative/absolute time string
 */
export var formatLastUpdatedTime = function formatLastUpdatedTime(dateString) {
  if (!dateString) return "";
  var date = typeof dateString === "string" ? parseISO(dateString) : new Date(dateString);
  var now = new Date();
  var seconds = differenceInSeconds(now, date);
  var minutes = differenceInMinutes(now, date);
  var hours = differenceInHours(now, date);
  var days = differenceInDays(now, date);
  if (seconds < 10) return "".concat(t("just_now"));
  if (seconds < 60) return "".concat(seconds, " ").concat(seconds !== 1 ? t("second_plural_key") : t("second_singular_key"), " ").concat(t("ago_key"));
  if (minutes < 60) return "".concat(minutes, " ").concat(minutes !== 1 ? t("minute_plural_key") : t("minute_singular_key"), " ").concat(t("ago_key"));
  if (hours < 24) return "".concat(hours, " ").concat(hours !== 1 ? t("hour_plural_key") : t("hour_singular_key"), " ").concat(t("ago_key"));
  if (days < 7) return "".concat(days, " ").concat(days !== 1 ? t("day_plural_key") : t("day_singular_key"), " ").concat(t("ago_key"));
  if (days < 30) return "".concat(Math.floor(days / 7), " ").concat(Math.floor(days / 7) !== 1 ? t("week_plural_key") : t("week_singular_key"), " ").concat(t("ago_key"));

  // Beyond ~1 month, show actual date/time
  var showYear = now.getFullYear() !== date.getFullYear();
  var dateFormat = showYear ? "MMM d, yyyy" : "MMM d";
  var timeFormat = format(date, "h:mmaaa").toLowerCase();
  return "".concat(timeFormat, ", ").concat(format(date, dateFormat));
};